'use strict';

module.exports = {
  PNG: 'png',
  JPEG: 'jpeg',
  IMAGE: 'image',
  CSV: 'csv',
  TEXT: 'text',
  GPX: 'gpx',
  TCX: 'tcx',
  FIT: 'fit',
  ANY: 'any',
};
